<template>
  <div id="member" class="crpg-o-half-plan-common">
    <div class="bloc fee wide">
      <h2>
        {{ content.fees }}<span
          >{{ content.taxIncluded }}</span
        >
      </h2>

      <table class="cp_pricetable3 box">
        <tbody>
          <tr>
            <td class="group1">
              <dl>
                <dt>{{ content.admissionFee }}</dt>
                <dd>
                  <strong>198,000</strong
                  >{{ content.circle }}<br />{{ content.firstYearOnly }}
                </dd>
              </dl>
            </td>
          </tr>
          <tr>
            <td class="group4">
              <dl>
                <dt>{{ content.annualFee }}</dt>
                <dd><strong>198,000</strong>{{ content.circle }}</dd>
              </dl>
            </td>
          </tr>
          <tr class="license">
            <td colspan="1">
              <dt>{{ content.eligibility }}</dt>
              <dd>
                {{ content.directors }}<br />
                {{ content.existingMembers }}
              </dd>
            </td>
          </tr>
        </tbody>
        <a id="entry" class="anchor_position"></a>
      </table>
    </div>
    <div class="bloc flow">
      <h2>{{ content.flow2membership }}</h2>
      <div class="content prime">
        <h3>{{ content.primeMember2 }}</h3>
        <ul>
          <li class="l1">
            <span class="num">1</span>
            <span class="text">
              <a :href="requestDocURL">{{ content.step1_1 }}</a>
              {{ content.step1_2 }}
            </span>
          </li>
          <li class="l2">
            <span class="num">2</span>
            <span class="text">{{ content.step2 }}</span>
          </li>
          <li class="l3">
            <span class="num">3</span>
            <span class="text"
              >{{ content.step3 }}</span>
          </li>
          <li class="l4">
            <span class="num">4</span>
            <span class="text">{{ content.step4 }}</span>
          </li>
          <li class="l5">
            <span class="num">5</span>
            <span class="text">{{ content.step5}}</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="bloc link brochure">
      <!-- 規約リンク -->
      <p class="crpg-pc">
        <a href="" @click.prevent.stop="activateAgree">{{ content.kiyaku1_1 }}</a>
        <span>{{ content.kiyaku1_2_pc }}</span>
      </p>
      <p class="crpg-sp crpg-line-feed">
        <a href="" @click.prevent.stop="activateAgree">{{ content.kiyaku1_1 }}</a>
        <span>{{ content.kiyaku1_2_sp }}</span>
      </p>
      <br />
      <!-- 規約チェックボックス -->
      <div class="agree-box">
        <input id="agree" type="checkbox" v-model="agree" class="checkbox" :disabled="isAgreeDisabled">
        <label for="agree"><span>{{ content.agree }}</span></label>
      </div>
      <ul>
        <li class="pamph">
          <a
            @click="entry"
            :class="[isDisabled ? 'disabled' : 'active']"
            >{{ content.btnEntry }}</a
          >
        </li>
        <li class="pamph"><a class="active" href="./">戻る</a></li>
      </ul>
    </div>
  </div>
</template>
<script>

import text from "@/assets/txt/about.json";
var obj = text;

export default {
  name: "FreeFoodContent",
  components: {},
  data() {
    return {
      content: obj,
      contentTopImage: require("@/assets/img/free_food.jpg"),
      contentTop: "アンティカ・オステリア・デル・ポンテ（東京/丸の内）",
      contentTopAlt: "アンティカ・オステリア・デル・ポンテ",
      contentTopText:
        "1年に1回、下記対象店舗の中からご希望のレストランを選び、1枚につき2名様までご利用いただけます。\n無料お食事ご招待券は、プレステージ・ゴールドへのご入会時、または更新時に1枚お送りします。",
      contentTopArea: "（東京/丸の内）",
      contentImageTitle: "【無料お食事ご招待券見本】",
      contentImageAlt: "無料お食事ご招待券見本",
      contentImage: require("@/assets/img/about_title.png"),

      // 非活性フラグ（入会ボタン）
      isDisabled: true,
      // 非活性フラグ（規約チェックボックス）
      isAgreeDisabled: true,
      // 規約同意フラグ
      agree: false,
      requestDocURL: process.env.VUE_APP_CRSD_URL + "inquiry"
    };
  },
  methods: {
    /**
     * アクティベーションキーの入力画面へ遷移
     */
    entry() {
      if (!this.isDisabled) {
        console.log("アクティベーションキーの入力画面URL", process.env.VUE_APP_BOAK);
        window.open(process.env.VUE_APP_BOAK);
      }
    },
    /**
     * 会員規約を表示する
     * 規約チェックボックスを有効にする
     */
    activateAgree() {
      this.isAgreeDisabled = false;
      console.log("会員規約URL", process.env.VUE_APP_USE_KIYAKU_URL);
      window.open(process.env.VUE_APP_USE_KIYAKU_URL);
    }
  },
  watch: {
    agree: function (newVal) {
      if (newVal) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/organisms/about/aboutContent2.scss";
</style>
